import { apiFetch } from "@/api/client";
import { useAuthStore } from "@/store/authStore";

export interface ReportJob {
  id: number;
  period: string;
  format: string;
  status: string;
  error: string | null;
  created_at: string;
  completed_at: string | null;
  download_url: string | null;
}

export interface ReportJobListResponse {
  items: ReportJob[];
  total: number;
}

export const listReports = () => apiFetch<ReportJobListResponse>("/reports");

export const generateReport = (period: string, format: string) =>
  apiFetch<ReportJob>("/reports", { method: "POST", body: JSON.stringify({ period, format }) });

export async function downloadReport(job: ReportJob): Promise<void> {
  if (!job.download_url) return;
  const { accessToken } = useAuthStore.getState();
  const res = await fetch(job.download_url, {
    credentials: "include",
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `radadmin-report-${job.period}-${job.id}.${job.format}`;
  link.click();
  URL.revokeObjectURL(url);
}
